import theBass from '@/assets/the-bass.png'
import theLights from '@/assets/the-lights.png'
import thePeople from '@/assets/the-people.png'
import theFreedom from '@/assets/the-freedom.png'
import theMystery from '@/assets/the-mystery.png'

export const QUIZ_QUESTIONS = [
  {
    id: 'energy',
    question: 'What pulls you to the crowd?',
    subtitle: 'Choose what moves you.',
    answers: [
      { text: 'The Bass', image: theBass, persona: 'courageous' },
      { text: 'The Lights', image: theLights, persona: 'inspirational' },
      { text: 'The People', image: thePeople, persona: 'authentic' },
      { text: 'The Freedom', image: theFreedom, persona: 'independent' },
      { text: 'The Mystery', image: theMystery, persona: 'visionary' },
    ],
  },
  {
    id: 'music',
    question: 'Muzica ta de seară?',
    answers: [
      { text: 'Hip-hop & Trap', icon: 'mic', persona: 'courageous' },
      { text: 'Pop & Mainstream', icon: 'sparkle', persona: 'inspirational' },
      { text: 'Indie & Alternative', icon: 'vinyl', persona: 'authentic' },
      { text: 'Electronic & House', icon: 'wave', persona: 'independent' },
      { text: 'Chill & Lo-fi', icon: 'moon', persona: 'visionary' },
    ],
  },
  {
    id: 'party',
    question: 'Tu la petrecere ești...',
    answers: [
      { text: 'Primul pe ring', icon: 'flame', persona: 'courageous' },
      { text: 'Sufletul grupului', icon: 'sun', persona: 'inspirational' },
      { text: 'Vocea autentică', icon: 'target', persona: 'authentic' },
      { text: 'Cel care face regulile', icon: 'crown', persona: 'independent' },
      { text: 'Observatorul vizionar', icon: 'crystal', persona: 'visionary' },
    ],
  },
]

export function calculatePersona(answers) {
  const scores = { courageous: 0, inspirational: 0, authentic: 0, independent: 0, visionary: 0 }
  answers.forEach((a) => { if (a?.persona) scores[a.persona]++ })
  return Object.entries(scores).sort((a, b) => b[1] - a[1])[0][0]
}
